import React, { useEffect } from 'react';
import '../StylesComponents/LegalPages.css';

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-container">
      <div className="legal-content-wrapper">
        <header className="legal-header">
          <div className="legal-id-badge">DATA_ENCRYPTION_MANIFEST_v1.0</div>
          <h1 className="legal-title">Privacy Policy</h1>
          <div className="legal-meta">
            <span>VERSION: 2026.02.15</span>
            <span>COMPLIANCE: APP_AUSTRALIA</span>
            <span>ENCRYPTION: AES-256_SSL</span>
          </div>
        </header>

        <section className="legal-section">
          <h2>01. Data Collection Node</h2>
          <p className="legal-text">
            To provide a premium shopping experience, Stockroom collects specific data points during your interaction with our "Engines":
          </p>
          <ul className="legal-list">
            <li><strong>Identity Data:</strong> Full name and email address for account management.</li>

            <li><strong>Behavioural Data:</strong> Anonymous technical data regarding your navigation through our product feeds.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>02. Data Processing Architecture</h2>
          <p className="legal-text">
            We share your data with essential third-party "Nodes" only to facilitate your experience:
          </p>
          <ul className="legal-list">
            <li><strong>Affiliate Networks:</strong> Anonymised tracking tokens to confirm commissions.</li>
            <li><strong>Analytics:</strong> Technical signals to optimise platform performance.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>03. Data Sovereignty</h2>
          <p className="legal-text">
            Your privacy is protected under the <strong>Privacy Act 1988 (Cth)</strong>. We do not sell your personal data to external marketing agencies. All data is stored on secure, encrypted servers with restricted internal access protocols.
          </p>
        </section>

        <section className="legal-section">
          <h2>04. Cookies and Tracking Signals</h2>
          <p className="legal-text">
            Our platform utilises technical cookies to:
          </p>
          <ul className="legal-list">
            <li>Persist your shopping bag across secure sessions.</li>
            <li>Optimise feed performance based on your region (e.g., Perth/WA).</li>
            <li>Monitor the integrity of our API Nexus connections.</li>
          </ul>
        </section>



        <footer style={{ marginTop: '80px', padding: '40px 0', borderTop: '1px solid #111', color: '#444', fontSize: '10px', fontFamily: 'monospace' }}>
          DOCUMENT_AUTHENTICATED // SYSTEM_ADMIN_STOCKROOM
        </footer>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
